import React from 'react';

import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { Song } from 'src/@types/api-types';

import ColormapInterface from 'shared-types/colormapinterface';

import { StyledControlBar } from './ControlBarContent.style';
import Controls from './Controls';
import Slider from './TimeSlider';
import VoiceControl from './VoiceControl';
import { AudioOptionButtonState } from './VoiceControl/AudioOptionButton/AudioOptionButton.const';

interface ControlBarContentProps {
  controlsDisabled: boolean;
  PlayPauseIcon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  handleRestartSongClick: () => void;
  handlePlayPauseClick: () => void;
  handlePlayNextSongClick: () => void;
  handleTimeSliderChange: (value: number | number[]) => void;
  handleTimeSliderChangeCommitted: () => void;
  handleToggleVocalGuideClick: () => void;
  nextSong: Song | null;
  songTitle?: string;
  songArtistName?: string;
  timeSliderValue: number;
  timeSliderMax: number;
  remainingTime: string | null;
  vocalGuideButtonState: AudioOptionButtonState;
  colors: ColormapInterface;
}

const ControlBarContent: React.FC<ControlBarContentProps> = ({
  controlsDisabled,
  PlayPauseIcon,
  handleRestartSongClick,
  handlePlayPauseClick,
  handlePlayNextSongClick,
  handleTimeSliderChange,
  handleTimeSliderChangeCommitted,
  handleToggleVocalGuideClick,
  nextSong,
  songTitle,
  songArtistName,
  timeSliderValue,
  timeSliderMax,
  remainingTime,
  vocalGuideButtonState,
  colors,
}) => {
  return (
    <StyledControlBar colors={colors}>
      <Controls
        {...{
          handleRestartSongClick,
          controlsDisabled,
          PlayPauseIcon,
          handlePlayPauseClick,
          handlePlayNextSongClick,
          nextSongId: nextSong?.id || null,
        }}
      />

      <Slider
        {...{
          songTitle,
          songArtistName,
          timeSliderValue,
          timeSliderMax,
          handleTimeSliderChange,
          remainingTime,
          handleTimeSliderChangeCommitted,
          controlsDisabled,
        }}
      />

      <VoiceControl {...{ handleToggleVocalGuideClick, vocalGuideButtonState }} />
    </StyledControlBar>
  );
};

export default ControlBarContent;
